import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../../hoc";
// import the corresponding css file
import "./ExperimentsKids.css";
// import the separated file related to the component
import EC20Experiments from "./EC20Experiments/EC20Experiments";
import SpaCExperiments from "./SpaCExperiments/SpaCExperiments";
import HGTExperiments from "./HorizontalGeneTransfer/HGTExperiments";
// import the image you want for the top of the page
import { BacteriaSlider } from "../../utils";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../../utils/scrollToId";

const Experiments = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
    // Simulate a delay (remove this in your actual implementation)
    let url = window.location.href;
    let lastLetter = url.charAt(url.length - 1);
    let secondLastLetter = url.charAt(url.length - 2);

    if (secondLastLetter === "_") {
      if (lastLetter === "e") {
        setPage(1);
      } else if (lastLetter === "s") {
        setPage(2);
      } else if (lastLetter === "h") {
        setPage(3);
      }
    }

    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading);
    if (!loading) {
      scrollToId();
    }
  }, [loading, setDisplayNavBar]);

  const [page, setPage] = useState(1);
  const sliderHandle = (newValue) => {
    setPage(newValue);
  };

  return (
    <>
      {" "}
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
        {loading ? (
          <div className="spinner-container fixed h-screen w-screen bg-white z-10">
            <RingLoader color="#BA55D3" loading={loading} />{" "}
            <script>{(document.body.style.overflow = "hidden")}</script>
          </div>
        ) : (
          <script>{(document.body.style.overflow = "auto")}</script>
        )}
        <>
          {" "}
          {/* Set the size and crop the image on top of the page */}
          <div className="top-page">
            <h1>Experiments</h1>
          </div>
          {/* divide the section in columns */}
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <div
            style={{
              marginRight: "50px",
              marginLeft: "50px",
            }}
          >
            <main className="prose ml-[2rem]">
              <p>
                To guarantee the performance of our LBP, we undertook several
                essential assessments. Our initial step was to ascertain the
                expression of our proteins on the bacterial surface. Beyond
                that, it was imperative to demonstrate the bacteria's capability
                to bind both to cadmium and mucus effectively. To methodically
                approach these LBP-related experiments, we divided them into
                three distinct phases. We began by performing experiments using
                bacteria transformed with either SpaC or EC20 constructs. Our
                subsequent goal was to merge these two constructs, then re-run
                the same experiments to assess the compatibility and
                functionality of the double mutant configuration. Regrettably,
                time constraints prevented us from completing the tests on these
                double mutants, earmarking them for future exploration. As a
                concluding step, we undertook experiments related to horizontal
                gene transfer (H.G.T) as a proof of concept, applicable to our
                LBP in the future. Detailed protocols for each experiment are
                accessible by selecting the plus symbol at the close of each
                section. However, not all the protocols are presented here. For
                a comprehensive list, please refer to the designated page: 
                <a href="../protocols">protocols page</a>
              </p>
            </main>
          </div>
          <BacteriaSlider value={page} onChange={sliderHandle} />
          <main style={{ marginRight: "50px" }}>
            {page === 1 ? (
              <div className="fade-in mt-[2rem]">
                <EC20Experiments />
              </div>
            ) : page === 2 ? (
              <div className="fade-in1 mt-[2rem]">
                <SpaCExperiments />
              </div>
            ) : page === 3 ? (
              <div className="fade-in2 mt-[2rem]">
                <HGTExperiments />
              </div>
            ) : (
              <></>
            )}{" "}
          </main>
        </>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Experiments, "engineering");
